<template>
  <div class="image-template" :class="[mapSize,mapLayout,$root.env]">
    <div>
      <img
          v-if="cropImg"
          :src="cropImg"
          alt="Cropped Image"
      />
    </div>
  </div>
</template>

<script>
import ImageTemplateModule from '../store-mixin'

export default {
  name: 'ImageTemplate',
  mixins: [ImageTemplateModule()],
}
</script>

<style lang="scss">

//Dont forget to add or change fonts in shopkeeper-child/include/textArtProducts/assets/fonts

@font-face {
  font-family: 'Futura PT';
  src: url('../assets/fonts/FuturaPT-Bold.eot');
  src: url('../assets/fonts/FuturaPT-Bold.eot?#iefix') format('embedded-opentype'),
  url('../assets/fonts/FuturaPT-Bold.woff2') format('woff2'),
  url('../assets/fonts/FuturaPT-Bold.woff') format('woff'),
  url('../assets/fonts/FuturaPT-Bold.ttf') format('truetype'),
  url('../assets/fonts/FuturaPT-Bold.svg#FuturaPT-Bold') format('svg');
  font-weight: bold;
  font-style: normal;
  font-display: swap;
}

@font-face {
  font-family: 'Cardo';
  src: url('../assets/fonts/Cardo-Regular.eot');
  src: url('../assets/fonts/Cardo-Regular.eot?#iefix') format('embedded-opentype'),
  url('../assets/fonts/Cardo-Regular.woff2') format('woff2'),
  url('../assets/fonts/Cardo-Regular.woff') format('woff'),
  url('../assets/fonts/Cardo-Regular.ttf') format('truetype'),
  url('../assets/fonts/Cardo-Regular.svg#Cardo-Regular') format('svg');
  font-weight: normal;
  font-style: normal;
  font-display: swap;
}

@font-face {
  font-family: 'Blacksword';
  src: url('../assets/fonts/Blacksword.eot');
  src: url('../assets/fonts/Blacksword.eot?#iefix') format('embedded-opentype'),
  url('../assets/fonts/Blacksword.woff2') format('woff2'),
  url('../assets/fonts/Blacksword.woff') format('woff'),
  url('../assets/fonts/Blacksword.ttf') format('truetype'),
  url('../assets/fonts/Blacksword.svg#Blacksword') format('svg');
  font-weight: normal;
  font-style: normal;
  font-display: swap;
}

@font-face {
  font-family: 'Futura XBlk BT';
  src: url('../assets/fonts/FuturaBT-ExtraBlack.eot');
  src: url('../assets/fonts/FuturaBT-ExtraBlack.eot?#iefix') format('embedded-opentype'),
  url('../assets/fonts/FuturaBT-ExtraBlack.woff2') format('woff2'),
  url('../assets/fonts/FuturaBT-ExtraBlack.woff') format('woff'),
  url('../assets/fonts/FuturaBT-ExtraBlack.ttf') format('truetype'),
  url('../assets/fonts/FuturaBT-ExtraBlack.svg#FuturaBT-ExtraBlack') format('svg');
  font-weight: 900;
  font-style: normal;
  font-display: swap;
}

@font-face {
  font-family: 'Amatic SC';
  src: url('../assets/fonts/AmaticSC-Bold.eot');
  src: url('../assets/fonts/AmaticSC-Bold.eot?#iefix') format('embedded-opentype'),
  url('../assets/fonts/AmaticSC-Bold.woff2') format('woff2'),
  url('../assets/fonts/AmaticSC-Bold.woff') format('woff'),
  url('../assets/fonts/AmaticSC-Bold.ttf') format('truetype'),
  url('../assets/fonts/AmaticSC-Bold.svg#AmaticSC-Bold') format('svg');
  font-weight: bold;
  font-style: normal;
  font-display: swap;
}

@font-face {
  font-family: 'Futura PT Book';
  src: url('../assets/fonts/FuturaPT-Book.eot');
  src: url('../assets/fonts/FuturaPT-Book.eot?#iefix') format('embedded-opentype'),
  url('../assets/fonts/FuturaPT-Book.woff2') format('woff2'),
  url('../assets/fonts/FuturaPT-Book.woff') format('woff'),
  url('../assets/fonts/FuturaPT-Book.ttf') format('truetype'),
  url('../assets/fonts/FuturaPT-Book.svg#FuturaPT-Book') format('svg');
  font-weight: normal;
  font-style: normal;
  font-display: swap;
}

//@font-face {
//  font-family: 'Futura PT Book';
//  src: url('../assets/fonts/FuturaPT-Book_1.eot');
//  src: url('../assets/fonts/FuturaPT-Book_1.eot?#iefix') format('embedded-opentype'),
//  url('../assets/fonts/FuturaPT-Book_1.woff2') format('woff2'),
//  url('../assets/fonts/FuturaPT-Book_1.woff') format('woff'),
//  url('../assets/fonts/FuturaPT-Book_1.ttf') format('truetype'),
//  url('../assets/fonts/FuturaPT-Book_1.svg#FuturaPT-Book') format('svg');
//  font-weight: normal;
//  font-style: normal;
//  font-display: swap;
//}


</style>

<style lang="scss" scoped>


img {
  width: 100%;
  height: auto
}

.image-template {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  flex-direction: column;
  text-align: center;

  ::v-deep * {
    color: black;
    font-size: 72px;
    font-family: unset;
    margin: 0;
  }


  .main {
    padding-top: 14px;

    ::v-deep * {
      font-family: SF Slapstick Comic Shaded;
      font-size: 72px;
      margin: 0;
      line-height: 0;
      margin-bottom: 100px;
      letter-spacing: 1px;
    }
  }

  .secondary {
    margin: 10px;

    ::v-deep {
      font-family: Montserrat B;
      font-size: 27px;
      font-weight: bold;
      letter-spacing: -0.3px;
    }
  }

}
</style>

